import ID from '../models/ID'

// Returns the items for the given IDs that exist in the lookup, in ID order, skipping unknown IDs
export function lookupByIds<T>(itemsById: Map<number, T>, ids: ID[]): T[] {
  const items = [] as T[]
  ids.forEach((id) => {
    const item = itemsById.get(id.intID)
    if (item) {
      items.push(item)
    }
  })
  return items
}

// Returns the items whose ID is in ids, keeping the items' own order
export function filterByIds<T extends {id: ID}>(items: T[], ids: ID[]): T[] {
  const idSet = new Set(ids.map((id) => id.intID))
  return items.filter((item) => idSet.has(item.id.intID))
}
